import { BASE_METHODS, CustomErrorType } from "../../constants/action-types";
import {
  removeCompanyFromCompanies,
  setCompanyActionStart,
  setCompanyErrorMessage,
} from "../../constants/reducers/company.reducer";
import { store } from "../../store";
import { createCall } from "../base";
import { plainToClass } from "class-transformer";
import { validate } from "class-validator";
import { TextEnum } from "../../constants/text";
import { timeoutError } from "../../constants/reducers/base.reducer";
import { AxiosResponse } from "axios";
import { ModifyCompanyDTO } from "../../constants/dto/company";

let body: ModifyCompanyDTO;

export const modifyCompany = async () => {
  store.dispatch(setCompanyActionStart(true));
  const { name, taxNumber, company } = store.getState().company;

  const params = {
    id: company.id,
    name,
    taxNumber,
  };
  const request = await createCall(
    `cms/companies/modify`,
    BASE_METHODS.PUT,
    "application/json",
    "1.0.0",
    params,
    undefined
  );

  try {
    const response = request as AxiosResponse;
    body = plainToClass(ModifyCompanyDTO, response.data);
    const errors = await validate(body);
    if (errors.length > 0) {
      store.dispatch(
        setCompanyErrorMessage(TextEnum.MODIFY_COMPANY_INVALID_RESPONSE)
      );
      return;
    }
    store.dispatch(removeCompanyFromCompanies(company.id));
    return response;
  } catch (error) {
    const responseError = request as any;
    const errorResponeData: CustomErrorType = responseError.response?.data;
    if (errorResponeData) {
      let errorMessage = "";
      switch (errorResponeData.code) {
        case 2001:
          errorMessage = TextEnum.MODIFY_COMPANY_COMPANY_NOT_FOUND;
          break;
        case 2002:
          errorMessage = TextEnum.MODIFY_COMPANY_COMPANY_ALREADY_EXIST;
          break;
        case 2005:
          errorMessage = TextEnum.CREATE_COMPANY_INVALID_COMPANY_ADDRESS;
          break;
        default:
          break;
      }
      store.dispatch(setCompanyErrorMessage(errorMessage));
      return;
    }
    store.dispatch(setCompanyActionStart(false));
    store.dispatch(timeoutError());
    return;
  }
};
